var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptedTentatively(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33301 11.9997H8.66634V10.6663H7.33301V11.9997ZM7.99967 1.33301C4.31967 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31967 14.6663 7.99967 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99967 1.33301ZM7.99967 13.333C5.05967 13.333 2.66634 10.9397 2.66634 7.99967C2.66634 5.05967 5.05967 2.66634 7.99967 2.66634C10.9397 2.66634 13.333 5.05967 13.333 7.99967C13.333 10.9397 10.9397 13.333 7.99967 13.333ZM7.99967 3.99967C6.52634 3.99967 5.33301 5.19301 5.33301 6.66634H6.66634C6.66634 5.93301 7.26634 5.33301 7.99967 5.33301C8.73301 5.33301 9.33301 5.93301 9.33301 6.66634C9.33301 7.99967 7.33301 7.83301 7.33301 9.99967H8.66634C8.66634 8.49967 10.6663 8.33301 10.6663 6.66634C10.6663 5.19301 9.47301 3.99967 7.99967 3.99967Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedTentatively);
export default __webpack_public_path__ + "static/media/accepted_tentatively.4f3c57df9c43e3c9fd1b5c3647750f82.svg";
export { ForwardRef as ReactComponent };